export default {
  NewAppVersionAdd: 'برنامه جدید اضافه شد',
  UpdateAppVersion: 'برنامه بروزرسانی شد',
  AppVerstionRemoved: 'برنامه حذف شد',
  UpdateVariable: 'متغیر بروزرسانی شد',

  Application: 'اپلیکیشن',
  AppType: 'نوع برنامه',
  Enable: 'فعال',
  Download: 'دانلود',
  Code: 'کد',
  ForceDownload: 'دانلود اجباری',
  Description: 'توضیحات',
  ReleaseTime: 'تاریخ انتشار',
  ReleaseTimeMin: 'تاریخ انتشار از',
  ReleaseTimeMax: 'تاریخ انتشار تا',
  Version: 'نسخه',
  Variable: 'متغیر',
  Value: 'مقدار',
  Variabletype: 'نوع متغیر',
  Stable: 'ثبات',
  Features: 'امکانات',
  uploadedIn: 'آپلود شده در',
  playStore: 'پلی استور',
  cafeBazaar: 'کافه بازار',
  myket: 'مایکت',
  typeTitle: 'نوع',
  referenceId: 'شناسه داخلی',
  externalSystemTitle: 'سیستم خارجی',
  externalCode: 'کد سیستم خارجی',
  missType: 'نوع فقدان',
  notSupported: 'عدم پشتیبانی',
  addToDictionary: 'افزودن به دیکشنری',
  internalSystemTitle: 'سیستم داخلی',
  dictionaryBased: 'بر اساس دیکشنری',
  sendMethod: 'روش ارسال',
  token: 'توکن',
  tokenBased: 'بر اساس توکن',

  //
  editProfile: 'ویرایش پروفایل',
  loginViaOtp: 'ورود با رمز یکبار مصرف',
  confirmEmailRequired: 'تکرار ایمیل',
  confirmMobileRequired: 'تکرار موبایل',
  loginViaEmail: 'ورود با ایمیل',
  loginViaSms: 'ورود با پیامک',
  twoFactorEnabled: 'ورود دو مرحله ای',
  confirm: 'نیازمند تائید',

  //
  registerByOtp: 'رمز یکبار مصرف',
  required: 'الزامی',

  // security
  lengthMin: 'حداقل طول',
  lengthMax: 'حداکثر طول',
  character: 'کاراکتر',
  lowerCase: 'حرف کوچک',
  upperCase: 'حرف بزرگ',
  specialCharacter: 'کاراکتر خاص',
  number: 'عدد',
  jwt: 'jwt',
  minute: 'دقیقه',
  second: 'ثانیه',
  accessTokenWebExpireMinute: 'انقضای توکن وبسایت',
  accessTokenAndroidExpireMinute: 'انقضای توکن اپلیکیشن',
  refreshTokenAndroidExpireMinute: 'انقضای رفرش توکن اپلیکیشن',
  refreshTokenWebExpireMinute: 'انقضای رفرش توکن وبسایت',
  accessTokenWebAdminExpireMinute: 'انقضای توکن پنل ادمین',
  refreshTokenWebAdminExpireMinute: 'انقضای رفرش توکن پنل ادمین',
  accessTokenWebCompanyExpireMinute: 'انقضای توکن پنل پروژه',
  refreshTokenWebCompanyExpireMinute: 'انقضای رفرش توکن پنل پروژه',
  accessTokenAndroidAdminExpireMinute: 'انقضای توکن اپلیکیشن پنل ادمین',
  refreshTokenAndroidAdminExpireMinute: 'انقضای رفرش توکن اپلیکیشن پنل ادمین',
  accessTokenAndroidCourierExpireMinute: 'انقضای توکن اپلیکیشن پنل پروژه',
  refreshTokenAndroidCourierExpireMinute: 'انقضای رفرش توکن اپلیکیشن پنل پروژه',
  accessTokenAndroidDriverExpireMinute: 'انقضای توکن اپلیکیشن راننده',
  refreshTokenAndroidDriverExpireMinute: 'انقضای رفرش توکن اپلیکیشن راننده',
  lock: 'قفل شدن',
  time: 'مرتبه',
  accessFailedLimit: 'حداکثر اشتباه مجاز',
  accessFailedCritical: 'آستانه بلاک کاربر به دلیل تلاش ناموفق',
  durationMinute: 'مدت قفل شدن کاربر',

  // order
  draftExpireMinute: 'مدت اعتبار پیش نویس سفارش',
  minOrderIntervalFromCancelMinute: 'حداقل فاصله زمانی کنسلی سفارش',
  minOrderIntervalFromRequestMinute: 'حداقل فاصله زمانی سفارش',
  priceExpireMinute: 'مدت اعتبار قیمت اولیه سفارش',
  publishIntervalSecond: 'فاصله زمانی ارسال رانندگان',
  publishBranchIntervalSecond: 'فاصله زمانی انتصاب به نزدیکترین شعبه',
  publishAreaSequence: 'محدوده مکانی ارسال رانندگان',

  cargo: 'بار سنگین',
  furniture: 'اسباب کشی',
  postage: 'مرسوله پستی',
  delivery: 'پیک',
  pickup: 'وانت',
  material: 'مصالح',
  trash: 'نخاله',

  // driver
  maxNonExpireMinute: 'حداکثر زمان مشاهده موقعیت راننده های فعال',
  maxOfflineMinute: 'حداکثر زمان ارسال آخرین موقعیت توسط راننده فعال',
  minInitiateMinute: 'حداقل زمان شروع سفارش راننده',

  download: 'دانلود',
  basePackage: 'basePackageJava',
  bucket: 'Bucket',
  container: 'container',
  name: 'نام',
  group: 'نام گروه',
  moduleName: 'نام ماژول',
  restBaseUrl: 'restBaseUrl',
  maxLength: 'حداکثر طول',
  fields: 'فیلدها',
  test: 'تست',
  admin: 'ادمین',
  minimumSdk: 'حداقل SDK',

  //general
  newNumber: 'شماره جدید',
  adminNumber: 'شماره های ادمین',
  numberExist: 'شماره وارد شده موجود است',
  settingsUpdated: 'شماره های ادمین بروز شد',

  //webService
  service: 'سرویس',
  atLeastOneRequired: 'حداقل یک سرویس و عملیات مورد نیاز است',
  serviceAndOperationExist: 'سرویس و عملیات موجود است',
  containerIsRequired: 'فیلد کانتینر الزامی است',
  containerAndBucketIsRequired: 'فیلد کانتینر و باکت الزامی است',
  privateKey: 'کلید شخصی',
  smtpUrl: 'لینک SMTP',
  authorization: 'احراز هویت',
  connectionInfo: 'اطلاعات تماس',
  userNamePassword: 'نام کاربری و رمز عبور',
  authorizationType: 'نوع احراز هویت',
  monitor: 'پایش',
  shipper: 'صاحب کالا',
  public: 'عمومی',
  curator: 'متصدی'
}
